import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7a2a0bfe&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/form.scss?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./App.vue?vue&type=style&index=1&module=col&lang=css&"
import style2 from "./App.vue?vue&type=style&index=2&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)
this["col"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports